import { ComponentClassNames } from '../../util/classNames';
import { IRawStyle, memoizeFunction, mergeStyleSets } from '../../util/styling';

import { HorizontalAligns, VerticalAlignProps, VerticalAligns } from './VerticalAlign.types';

const alignment: Record<VerticalAligns, IRawStyle['justifyContent']> = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end',
};

const horizontalFlexAlignment: Record<HorizontalAligns, IRawStyle['alignItems']> = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
};

type VerticalAlignClassNames = ComponentClassNames<'verticalAlign' | 'inner'>;

export const getClassNames = memoizeFunction(
  (
    align: VerticalAligns,
    horizontalAlign: HorizontalAligns,
    height: VerticalAlignProps['height'],
    className: VerticalAlignProps['className']
  ): VerticalAlignClassNames =>
    mergeStyleSets({
      verticalAlign: [
        {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: alignment[align],
          alignItems: horizontalFlexAlignment[horizontalAlign],
          textAlign: horizontalAlign,
          height,
        },
        className,
      ],
      inner: {
        width: horizontalAlign === 'left' ? '100%' : undefined,
        maxWidth: '100%',
      },
    })
);
